<template>
  <div :class="classes">
      <pt-page-title title="银行分期返惠审核" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
      </pt-page-title>
      <pt-page-menu-filter :tabs="selectTabs" v-model="selectTab" state="status" @select="select"></pt-page-menu-filter>
          <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="filter">
          <el-button type="primary" @click="filter()">筛选</el-button>
          <el-button type="primary" @click="exportFlashBorrow">导出</el-button>
           <el-button type="primary" @click="exportHistoryFlashBorrow">导出历史</el-button>
          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </pt-page-factor-filter>
      <pt-fast-loan-audit-table :tableLabels="tableLabels" :paramsData="paramsData" ref="table">
          <el-table-column label="操作">
              <template slot-scope="scope">
                  <el-button type="text" @click="getDetail(scope.row)">详情</el-button>
                  <el-button type="text" @click="reviewPass(scope.row)" v-if="scope.row.status==='WAITING_FOR_AUDIT'&&HAS_PERM_FLASH_BORROW">审核通过</el-button>
                  <el-button type="text" v-if="scope.row.status==='WAITING_FOR_COMPLETE'&&HAS_PERM_FLASH_COMPLETED" @click="completed(scope.row)">发放</el-button>
              </template>
          </el-table-column>
      </pt-fast-loan-audit-table>
      <el-dialog :visible="is_dialog"  :title="dialog_title" @close="closeDialog" :class="$style['fast-loan-audit-dialog']">
          <flash-borrow-audit v-if="isReview" @closeDialog="closeDialog" :id="auditId"></flash-borrow-audit>
      </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import { selectTabs, filterLabels, tableLabels } from './fast-loan-options.js'
import ptFastLoanAuditTable from './pt-fast-loan-audit-table/withData'
import flashBorrowAudit from './flash-borrow-audit'
import { emptyObject } from '@/utils/lifebankUtils'
import { hasPermissions } from 'utils/permissions'
const prefixCls = 'pt-fast-loan-audit'
const PERM_FLASH_COMPLETED = 'PERM_FLASH_COMPLETED'// 闪贷返现财务审核权限
const PERM_FLASH_BORROW = 'PERM_FLASH_BORROW'// 闪贷返现客服审核权限
export default {
  name: 'pt-fast-loan-audit',
  components: {
    ptFastLoanAuditTable,
    flashBorrowAudit
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {

      set: function (val) {
        this.isReview = val
      },
      get: function () {
        return this.isReview
      }
    },
    page () {
      return this.$refs.table.page
    },
    HAS_PERM_FLASH_COMPLETED () { // 闪贷返现财务审核权限（发放）
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_FLASH_COMPLETED)
    },
    HAS_PERM_FLASH_BORROW () { // 闪贷返现客服审核专员
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_FLASH_BORROW)
    },
    tableData () {
      return this.$refs.table.tableData
    }
  },
  props: {
    allCitys: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      selectTabs: selectTabs,
      selectTab: null,
      searchKey: null,
      filterLabels: filterLabels,
      tableLabels: tableLabels,
      params: {},
      paramsData: {},
      isFromRouter: false,
      dialog_title: '银行分期返惠审核',
      isReview: false,
      auditId: null
    }
  },
  watch: {
    allCitys: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'city') {
            item.options = val
          }
        })
      },
      deep: true
    }
    // selectTab: {
    //   handler: function (val) {

    //   }
    // }
  },
  methods: {
    reviewPass (row) {
      this.isReview = true
      this.auditId = row.id
    },
    completed (row) {
      this.$confirm('确定完成改银行分期返惠提现吗。', '完成提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('flashBorrowCompleted', row)
      })
    },
    getTableData (page) {
      this.$refs.table.getTableData(page)
    },
    closeDialog (val) {
      if (val) {
        this.getTableData(this.page)
      }
      this.isReview = false
    },
    getDetail (row) {
      this.$router.push('/fast-loan-audit/fast-loan-audit-detail/' + row.id)
    },
    select (val) {
      for (var key in this.paramsData) {
        this.$delete(this.paramsData, key)
      }
      for (var key1 in this.params) {
        this.$delete(this.params, key1)
      }
      if (val !== 'ALL') {
        this.paramsData.status = val
      }
      this.$refs.table.resetPage()
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.paramsData.searchKey = val
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.paramsData, 'searchKey')
    },
    filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (key === 'applyTime') {
          this.paramsData = { ...this.params.applyTime, ...this.paramsData }
          this.$delete(this.paramsData, 'applyTime')
          this.$delete(this.paramsData, 'index')
        }
      }
      this.paramsData = { ...this.paramsData, ...this.params }
    },
    cleanParams () {
      for (var key in this.paramsData) {
        if (key !== 'status') {
          this.$delete(this.paramsData, key)
        }
      }
      for (var key1 in this.params) {
        if (key !== 'status') {
          this.$delete(this.params, key1)
        }
      }
    },
    exportFlashBorrow () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          for (var key in this.params) {
            if (!this.params[key]) {
              this.$delete(this.params, key)
            }
            if (key === 'applyTime') {
              this.$delete(this.params[key], 'index')
              this.params = { ...this.params, ...this.params[key] }
              this.$delete(this.params, key)
            }
          }
          if (this.selectTab !== 'ALL') {
            this.params.status = this.selectTab
          }
          this.params.status = this.params.status === 'ALL' ? null : this.params.status
          this.params.searchKey = this.searchKey ? this.searchKey : null
          this.$emit('flashBorrowExport', this.params)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryFlashBorrow () {
      this.$router.push('/export-history/fast-loan-audit/?name=flash_borrow_export')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.fast-loan-audit-dialog{
    :global
    .el-dialog{
        width: 30%;
        min-width: 380Px;
    }
}
</style>
